import React, { memo } from 'react';
import noop from 'lodash/noop';
// eslint-disable-next-line jira/import/no-restricted-import
import { RealtimeProvider } from '@atlassian/jira-realtime/src/services/realtime-provider/index.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import Realtime from '@atlassian/jira-realtime/src/main.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import type { RealtimeEvent } from '@atlassian/jira-realtime/src/common/types/events.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { APP_ID } from '../../model/constants.tsx';
import { useBacklogSelector } from '../../state/index.tsx';
import { REALTIME_EVENTS } from '../../model/realtime/constants.tsx';
import { realtimeChannelsSelector } from '../../state/selectors/realtime/index.tsx';

export type Props = {
	onReceive?: (eventType: RealtimeEvent) => void; // TODO: make it required with 'jira_replace_provider_and_client_with_realtime' feature gate clean up
	children?: JSX.Element; // TODO: remove with 'jira_replace_provider_and_client_with_realtime' feature gate clean up
};

const RealtimeWrapper = memo((props: Props) => {
	const realtimeChannels = useBacklogSelector(realtimeChannelsSelector);

	if (!fg('jira_replace_provider_and_client_with_realtime')) {
		if (realtimeChannels?.length === 0) {
			return props.children;
		}

		return (
			<RealtimeProvider
				appId={APP_ID}
				onJoin={noop}
				onReceive={noop}
				onLeave={noop}
				channels={realtimeChannels}
			>
				{props.children}
			</RealtimeProvider>
		);
	}

	if (realtimeChannels?.length === 0) {
		return null;
	}

	return (
		<Realtime
			appId={APP_ID}
			channels={realtimeChannels}
			events={REALTIME_EVENTS}
			onJoin={noop}
			onLeave={noop}
			onReceive={props.onReceive ?? noop}
		/>
	);
});

export default RealtimeWrapper;
